// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Info from '../_raw/ui/icon_info.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Info);
